import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default class OperatorStatusChangedInAnotherApp extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "operatorsOnlineUpdated";
    }

    public receive(payload: CometOperatorApplication.OperatorsOnlineUpdatedCometMessageOpenApiModel): void {
        OperatorAccountStore.receiveOperatorsOnlineUpdate(payload);
    }

}